import { createI18n, I18n, useI18n } from "vue-i18n";
import { en, es, fr, it } from "vuetify/locale";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import enYeti from "@/assets/i18n/en.json";
import esYeti from "@/assets/i18n/es.json";
import frYeti from "@/assets/i18n/fr.json";
import itYeti from "@/assets/i18n/it.json";

const messages = {
  en: { $vuetify: { ...en }, ...enYeti },
  es: { $vuetify: { ...es }, ...esYeti },
  fr: { $vuetify: { ...fr }, ...frYeti },
  it: { $vuetify: { ...it }, ...itYeti },
};

type MessageSchema = typeof messages.en;

export const i18n = createI18n<MessageSchema, "en">({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  globalInjection: false, // we favor the composition API
  locale: localStorage.getItem("locale") || window.navigator.language.split("-")[0], // If uses nav lang we only need the `en` from `en-US`
  fallbackLocale: "en",
  messages,
});

export const i18nAdapter = createVueI18nAdapter({
  // eslint-disable-next-line
  i18n: i18n as unknown as I18n<any, {}, {}, string, false>,
  useI18n,
});
